export function formatHistoryData(data?: string): string {
	if (!data) return ''
	try {
		return JSON.stringify(JSON.parse(data), null, 2)
	} catch {
		return data
	}
}

/** Older version selected while history panel is open; undefined at current version. */
export function resolveSyncedHistoryVersion(
	historyActive: boolean,
	selectedVersion: number,
	versionMax: number,
): number | undefined {
	return historyActive && selectedVersion !== versionMax ? selectedVersion : undefined
}

/**
 * History preview applies only when browsing an older version.
 * At the current/latest version, `version` is undefined (live mode) even if the history panel is open.
 */
export function resolveHistoryPreviewVersion(version?: number) {
	return {
		isHistoryPreview: version != null,
		previewVersion: version,
	}
}
